// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__8i5tg","loader-scale":"styles_loader-scale__2QHQM"};